import useSeo from "@/hooks/useSeo";
import PageHeader from "@/components/feature/PageHeader";
import MemeGallery from "@/pages/memes/components/MemeGallery";
import { memes } from "@/mocks/memes";

const memesJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "表情包专区",
    url: "https://law818.cn/memes",
    inLanguage: "zh-CN",
    description: "网络热梗表情包素材合集，包含梗图、聊天必备表情包及其出处与使用场景。",
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://law818.cn/" },
      { "@type": "ListItem", position: 2, name: "表情包专区", item: "https://law818.cn/memes" },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "表情包素材列表",
    numberOfItems: memes.length,
    itemListElement: memes.map((meme, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: meme.title,
      image: meme.image,
    })),
  },
];

export default function Memes() {
  useSeo({
    title: "表情包专区 | 热梗梗图与聊天素材 - 513吃瓜",
    description:
      "513吃瓜表情包专区收录网络热梗梗图、聊天必备表情包，每张都标注出处与使用场景，点开就能看清什么时候用最合适。",
    keywords: "513吃瓜表情包,热梗表情包,梗图素材,聊天表情包,表情包出处",
    path: "/memes",
    jsonLd: memesJsonLd,
  });

  return (
    <>
      <PageHeader
        eyebrow="每周更新"
        title="表情包专区"
        desc="聊天没图了就来这儿翻。所有素材都标注了出处与适用场景，不用再猜这张图该在什么时候发。"
        crumbs={[{ label: "首页", path: "/" }, { label: "表情包专区" }]}
      />
      <MemeGallery />
    </>
  );
}